import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { ServicesState } from './types';

export default {
  state: {
    definitions: {},
    selected: {},
    customServicesErrors: {},
  } as ServicesState,
  mutations,
  actions,
  getters,
};
